module.exports = __webpack_public_path__ + "img/headLogo.653be860.png";